import { render, staticRenderFns } from "./ElementAdDfp.vue?vue&type=template&id=0cb1c799&scoped=true&"
import script from "./ElementAdDfp.vue?vue&type=script&lang=js&"
export * from "./ElementAdDfp.vue?vue&type=script&lang=js&"
import style0 from "./ElementAdDfp.vue?vue&type=style&index=0&id=0cb1c799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1c799",
  null
  
)

export default component.exports